import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue'
import MarkdownIt from 'markdown-it'
import MarkdownItIns from 'markdown-it-ins'


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkDown',
  props: {
  source: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props
const md = new MarkdownIt().use(MarkdownItIns)
const compiledMarkdown = computed(() => md.render(props.source))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "markdown-container",
    innerHTML: compiledMarkdown.value
  }, null, 8, _hoisted_1))
}
}

})